import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, UrlSegment, ActivatedRouteSnapshot,Route} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../../core/services/authentication/authentication.service';

@Injectable()
export class LabConfigurationGuard  {

  constructor(
    private router: Router, private authenticationService: AuthenticationService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    if (this.authenticationService.HasLabConfiguration()) {
      return true;
    }
    this.router.navigate(['/'], { replaceUrl: true });
  }


  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    if (this.authenticationService.HasLabConfiguration()) {
      return true;
    }
    this.router.navigate(['/'], { replaceUrl: true });
  }
}
